/** Only same-app absolute paths are allowed as post-login redirects (no open redirects). */
export function safeRedirect(value: string | null | undefined, fallback = "/situs"): string {
  if (!value) return fallback;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return fallback;
  if (value.startsWith("/masuk") || value.startsWith("/daftar") || value.startsWith("/auth/")) return fallback;
  return value;
}

export function loginPath(redirect: string): string {
  return `/masuk?redirect=${encodeURIComponent(redirect)}`;
}
